import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature13',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature13-page',
    },
    title: {
      className: 'feature13-title',
      children: [
        {
          name: 'title0',
          className: 'feature13-title-box',
          children: '产业优势',
        },
        {
          name: 'title1',
          className: 'feature13-title-box',
          children: '1+3+3+1 产业体系',
        },
      ],
    },
    bg: {
      className: 'bg',
      children: 'https://imm.86links.com/assets/landing/feature/%E8%83%8C%E6%99%AF3.png',
    },
    content: {
      className: 'feature13-content',
      children: [
        {
          name: 'title0',
          className: 'feature13-content-item',
          img: {
            className: 'feature13-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/crad%402x.png',
          },
          title: {
            className: 'feature13-content-item-title',
            children: '汽车产业',
          },
        },
        {
          name: 'title1',
          className: 'feature13-content-item',
          img: {
            className: 'feature13-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/crad%E5%A4%87%E4%BB%BD%402x.png',
          },
          title: {
            className: 'feature13-content-item-title',
            children: '战略新兴产业',
          },
        },
        {
          name: 'title2',
          className: 'feature13-content-item',
          img: {
            className: 'feature13-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/crad%E5%A4%87%E4%BB%BD%202%402x.png',
          },
          title: {
            className: 'feature13-content-item-title',
            children: '现代服务业',
          },
        },
        {
          name: 'title3',
          className: 'feature13-content-item',
          img: {
            className: 'feature13-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/crad%E5%A4%87%E4%BB%BD%203%402x.png',
          },
          title: {
            className: 'feature13-content-item-title',
            children: '新经济',
          },
        },
      ],
    },

  },
};
